import { generateId } from '@hotjar/webapp/lib/componentId';

interface Props {
  size: number;
}

// This icon can't be part of iconmoon because it contains gradients.
export const ThumbsDownIcon = ({ size = 24 }: Props): JSX.Element => {
  const gradientIdA = generateId('thumbsDownIconA');
  const gradientIdB = generateId('thumbsDownIconB');
  const gradientIdC = generateId('thumbsDownIconC');
  const gradientIdD = generateId('thumbsDownIconD');
  const gradientIdE = generateId('thumbsDownIconE');

  return (
    <svg
      enableBackground="new 0 0 128 128"
      viewBox="0 0 128 128"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
    >
      <radialGradient
        id={gradientIdE}
        cx="51.77"
        cy="31.401"
        r="87.039"
        gradientTransform="matrix(-.0021809 -1 -.7873 .001717 76.604 148.32)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD902" offset=".6" />
        <stop stopColor="#e7c500" offset="1" />
      </radialGradient>
      <path
        d="m62.05 122.19c-2.51 0-4.87-0.72-7.01-2.13-0.88-0.58-0.88-4.62-0.87-7.86 0.01-5.02 0.02-11.27-2-16.99-2.03-5.75-6.03-11.36-10.68-15-9.9-7.74-23.03-12.02-23.59-12.2-0.07-0.02-0.15-0.04-0.23-0.05-4.47-0.7-7.71-4.5-7.69-9.02l0.08-32.75c0.01-4.89 3.43-9.1 8.31-10.26 0.63-0.15 1.39-0.24 2.19-0.34 1.87-0.23 3.99-0.5 5.94-1.6 6.88-3.9 15.94-5.21 24.71-6.04 12.74-1.2 25.69-1.54 34.32-1.61 3 0 5.73 1.13 7.78 3.19 2.05 2.05 3.18 4.79 3.18 7.69l-0.05 42.21c-0.01 8.16-6.66 14.79-14.81 14.79h-0.13s-7.24-0.25-7.25-0.25c-0.62 0-1.18 0.39-1.4 0.97-1.49 3.95 0.16 9.76 2.06 16.49 1.61 5.69 3.27 11.57 3.06 16.54-0.32 7.18-8.2 14.22-15.92 14.22z"
        fill={`url(#${gradientIdE})`}
      />
      <path
        d="m85.61 7.83c2.51 0 4.86 0.98 6.63 2.75s2.74 4.12 2.74 6.63l-0.05 42.21c-0.01 7.33-5.98 13.3-13.31 13.3h-0.06l-7.2-0.25h-0.11c-1.24 0-2.37 0.77-2.81 1.94-1.66 4.41 0.04 10.44 2.02 17.42 1.58 5.57 3.21 11.34 3 16.07-0.28 6.34-7.55 12.79-14.41 12.79-2.13 0-4.14-0.59-5.97-1.75-0.42-1-0.41-4.3-0.41-6.74 0.01-5.13 0.02-11.52-2.09-17.5-2.12-6.01-6.3-11.88-11.17-15.68-10.11-7.9-23.49-12.27-24.05-12.45-0.15-0.05-0.3-0.08-0.45-0.11-3.73-0.59-6.44-3.76-6.42-7.54l0.08-32.75c0.01-4.19 2.95-7.81 7.15-8.8 0.56-0.13 1.27-0.22 2.03-0.32 1.91-0.24 4.29-0.54 6.49-1.78 6.64-3.76 15.51-5.03 24.11-5.85 12.68-1.2 25.59-1.53 34.19-1.6l0.07 0.01m0-3h-0.1c-9.04 0.07-21.85 0.43-34.45 1.62-10.18 0.96-18.68 2.47-25.31 6.22-2.48 1.41-5.51 1.26-7.73 1.79-5.49 1.3-9.44 6.07-9.46 11.71l-0.08 32.76c-0.02 5.23 3.79 9.7 8.96 10.51 0 0 13.32 4.29 23.12 11.96 3.68 2.87 7.95 7.97 10.19 14.32 3.74 10.58 0.23 23.46 3.46 25.6 2.51 1.66 5.19 2.38 7.84 2.38 8.74 0 17.07-7.86 17.41-15.66 0.48-10.99-7.71-25.93-5.21-32.57l7.24 0.25h0.12c8.99 0 16.3-7.29 16.31-16.29l0.05-42.21c0.02-6.85-5.53-12.39-12.36-12.39z"
        fill="#b89c02"
      />
      <path
        d="m66.12 65.5c1.88-5 1.9-12.8 0-17.62-2.75-6.96-9.48-13.05-17.25-14.12-1.9-0.26-0.77-2.01 1.12-1.75 8.41 1.16 19.79 4.57 22.75 12.12 8.12 20.75-1.38 31.62-5.62 28.38-2.04-1.58-2.06-4.18-1-7.01z"
        fill="#b89c02"
      />
      <radialGradient
        id={gradientIdD}
        cx="2621.1"
        cy="-453.3"
        r="20.331"
        gradientTransform="matrix(-1.3883 -.0794 -.0374 .6794 3724.9 585.35)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD902" offset=".5993" />
        <stop stopColor="#c4a600" offset="1" />
      </radialGradient>
      <path
        d="m95.63 78.7c-13.12 0-22.44-2.21-26.22-6.23-1.45-1.53-2.09-3.31-1.96-5.43 0.43-7.41 10.49-8.96 18.84-8.96 9.34 0 18.6 1.92 18.69 1.94 0.07 0.02 0.15 0.03 0.22 0.03 4.39 0.26 7.72 4.58 7.42 9.63-0.29 4.89-3.84 8.72-8.09 8.72-0.14 0-0.27 0-0.41-0.01h-0.09c-0.04 0-0.09 0-0.13 0.01-0.04-0.01-3.51 0.3-8.27 0.3z"
        fill={`url(#${gradientIdD})`}
      />
      <path
        d="m86.28 59.58c9.16 0 18.29 1.89 18.38 1.91 0.14 0.03 0.29 0.05 0.44 0.06 1.66 0.1 3.19 0.94 4.32 2.38 1.21 1.54 1.81 3.56 1.69 5.67-0.24 4.09-3.13 7.3-6.59 7.3-0.11 0-0.22 0-0.32-0.01-0.06 0-0.12-0.01-0.17-0.01-0.09 0-0.18 0-0.27 0.01-0.03 0-3.45 0.3-8.13 0.3-12.52 0-21.68-2.1-25.13-5.76-1.16-1.23-1.66-2.61-1.56-4.32 0.1-1.64 0.7-4.02 4.81-5.7 3-1.21 7.21-1.83 12.53-1.83m0-3c-9.81 0-19.85 2.06-20.34 10.37-0.67 11.52 18.27 13.25 29.69 13.25 4.89 0 8.4-0.32 8.4-0.32 0.17 0.01 0.33 0.01 0.5 0.01 5.01 0 9.25-4.42 9.58-10.13 0.34-5.89-3.61-10.91-8.83-11.22 0 0.01-9.39-1.96-19-1.96z"
        fill="#b89c02"
      />
      <radialGradient
        id={gradientIdC}
        cx="2719.2"
        cy="-648.52"
        r="18.753"
        gradientTransform="matrix(-1.6967 .001885 .0029133 .6804 4723 486.01)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD902" offset=".5993" />
        <stop stopColor="#c4a600" offset="1" />
      </radialGradient>
      <path
        d="m92.55 60.18c-10.91 0-23.91-1.83-23.91-10.57 0-8.73 13-10.57 23.91-10.57 9.26 0 17.68 1.35 17.76 1.36s0.16 0.02 0.24 0.02c4.21 0 7.48 5.12 7.48 9.53 0 4.18-3.07 8.84-7.48 8.84-0.08 0-0.16 0.01-0.24 0.02-0.09 0.02-8.51 1.37-17.76 1.37z"
        fill={`url(#${gradientIdC})`}
      />
      <path
        d="m92.55 40.55c9.12 0 17.44 1.33 17.52 1.34 0.16 0.03 0.32 0.04 0.48 0.04 3.22 0 5.98 4.41 5.98 8.03 0 3.47-2.56 7.34-5.98 7.34-0.16 0-0.32 0.01-0.48 0.04-0.08 0.01-8.38 1.34-17.52 1.34-6.83 0-12.26-0.72-16.15-2.15-5.61-2.06-6.26-4.94-6.26-6.92 0-1.99 0.65-4.86 6.26-6.92 3.88-1.42 9.32-2.14 16.15-2.14m0-3c-11.93 0-25.41 2.19-25.41 12.07s13.47 12.07 25.41 12.07c9.49 0 18-1.38 18-1.38 5.16 0 8.98-5.23 8.98-10.34s-3.82-11.03-8.98-11.03c0-0.01-8.52-1.39-18-1.39z"
        fill="#b89c02"
      />
      <radialGradient
        id={gradientIdB}
        cx="2763.2"
        cy="-460.57"
        r="20.446"
        gradientTransform="matrix(-1.3069 .0062595 .0045215 .6804 3714.6 311.48)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD902" offset=".5993" />
        <stop stopColor="#c4a600" offset="1" />
      </radialGradient>
      <path
        d="m91.85 24.59c-15.66 0-24.64-3.01-24.66-8.26 0-1.38 0.54-2.6 1.67-3.73 6.45-6.47 27.79-6.8 32-6.8 0.62 0 0.98 0.01 0.98 0.01 4.91 0 8.86 4.11 8.88 9.15 0.01 2.46-0.91 4.78-2.58 6.52-1.66 1.73-3.86 2.68-6.2 2.69-0.04 0-0.09 0-0.13 0.01-0.05 0.01-4.39 0.41-9.96 0.41z"
        fill={`url(#${gradientIdB})`}
      />
      <path
        d="m100.86 7.31c0.6 0 0.94 0.01 0.95 0.01h0.09c4.02 0 7.3 3.44 7.31 7.66 0.01 2.07-0.76 4.02-2.16 5.48-1.37 1.43-3.19 2.22-5.12 2.23-0.09 0-0.18 0-0.27 0.01-0.04 0-4.3 0.4-9.8 0.4-14.27 0-23.15-2.59-23.16-6.76 0-0.61 0.12-1.55 1.23-2.66 2.92-2.95 12.77-6.37 30.93-6.37m0-3c-5.86 0-35.2 0.57-35.16 12.03 0.03 8.31 15.45 9.75 26.16 9.75 5.71 0 10.08-0.41 10.08-0.41 5.69-0.02 10.29-4.82 10.27-10.72-0.02-5.89-4.63-10.65-10.31-10.65h-0.03-1.01z"
        fill="#b89c02"
      />
      <radialGradient
        id={gradientIdA}
        cx="2740.2"
        cy="-625.68"
        r="18.611"
        gradientTransform="matrix(-1.6358 .001885 .0028087 .6804 4589.2 452.27)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD902" offset=".5993" />
        <stop stopColor="#c4a600" offset="1" />
      </radialGradient>
      <path
        d="m91.29 41.26c-8.98 0-24.06-1.19-24.06-9.12 0-9.45 20.9-10.47 29.89-10.47 5.23 0 9.07 0.31 9.11 0.31h0.12c4.73 0 9.03 5 9.03 10.5 0 5.81-4.87 7.87-9.03 7.87-0.06 0-0.13 0-0.19 0.01-0.07 0.03-6.94 0.9-14.87 0.9z"
        fill={`url(#${gradientIdA})`}
      />
      <path
        d="m97.12 23.18c5.15 0 8.95 0.31 8.99 0.31 0.08 0.01 0.16 0.01 0.25 0.01 3.87 0 7.53 4.37 7.53 9 0 4.7-3.89 6.37-7.53 6.37-0.13 0-0.26 0.01-0.39 0.02-0.07 0.01-6.85 0.88-14.68 0.88-6.81 0-12.27-0.63-16.21-1.87-6.34-2-6.34-4.82-6.34-5.75 0-3.04 3.02-5.38 8.97-6.97 6.16-1.66 13.96-2 19.41-2m0-3c-11.99 0-31.39 1.6-31.39 11.97 0 8.8 14 10.62 25.56 10.62 8.13 0 15.06-0.9 15.06-0.9 5.64 0 10.53-3.2 10.53-9.37s-4.89-12-10.53-12c0 0-3.88-0.32-9.23-0.32z"
        fill="#b89c02"
      />
      <polygon points="27.79 13.1 23 32 21 15" fill="#b89c02" />
    </svg>
  );
};
